import React from 'react';

const QuoteView = ({ data = {}, isEditMode = false }) => {
  const quote = (data.quote || 'Hier steht ein Zitat.').trim();
  const author = (data.author || '').trim();
  const bg = data.background_color || 'gray';

  const themeClass = `fcmh-quote--${bg}`;
  const quoteId = `quote-${data?.block || 'default'}`;

  return (
    <section className={`fcmh-quote ${themeClass}`} aria-labelledby={quoteId}>
      <div className="fcmh-quote__inner">
        <blockquote className="fcmh-quote__text" id={quoteId}>
          {quote}
        </blockquote>
        {author && <p className="fcmh-quote__author">{author}</p>}
      </div>
    </section>
  );
};

export default QuoteView;
